(function () {
    'use strict';
    /**
     * Module for IBFNPA view 
     */
    angular.module('ib-flight-now-module', [
        'ib-tab-slices-fn-module'
    ]);
})();